export class Storage {
}
//# sourceMappingURL=Storage.js.map